import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HandoverCommentResponse, HandoverCommentState } from '@handover/shared-types';
import { handoverCommentApi } from './commentApi';

const initialState: HandoverCommentState = {
  comments: null,
  status: 'idle',
  error: null,
};

const handoverCommentSlice = createSlice({
  name: 'handoverComments',
  initialState,
  reducers: {
    setComments: (state, action: PayloadAction<HandoverCommentResponse>) => {
      state.comments = action.payload;
    },
    clearComments: state => {
      state.comments = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(handoverCommentApi.endpoints.getHandoverCommentsByHandoverId.matchPending, state => {
        state.status = 'loading';
      })
      .addMatcher(
        handoverCommentApi.endpoints.getHandoverCommentsByHandoverId.matchFulfilled,
        (state, action: PayloadAction<HandoverCommentResponse>) => {
          state.status = 'succeeded';
          state.comments = action.payload;
        }
      )
      .addMatcher(handoverCommentApi.endpoints.getHandoverCommentsByHandoverId.matchRejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Failed to load comments';
      });
  },
});

export const { setComments, clearComments } = handoverCommentSlice.actions;
export default handoverCommentSlice.reducer;
